//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/RoutingCommon.js";
import "../no/Builder.js";
import "../Routing/Routing.RouteObjectCollector.js";
import "../GeometricUtilities/GeometricUtilities.ModlMotion.js";
import "../no/Expression.js";
import "../Assemblies/Assemblies.SelectComponent.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/Routing.js";
import "../no/SelectObject.js";
let d=[[[0,"CopyModeType",1,0],[0,"DetachType",1,0],[1,"EndObject",0,"Routing.RouteObjectCollector",0],[0,"MaintainLength",1,0],[1,"Motion",0,"GeometricUtilities.ModlMotion",0],[0,"MoveSubType",1,0],[0,"NumberOfCopies",1,0],[1,"PathSelection",0,"Routing.RouteObjectCollector",0],[0,"Preview",1,0],[1,"RotationAngle",0,"Expression",0],[1,"StartObject",0,"Routing.RouteObjectCollector",0],[1,"TargetAssembly",0,"Assemblies.SelectComponent",0]],[[[],"StartDrag",{},0,0],[[],"DragObjects",{},0,0],[[],"StopDrag",{},0,0],[[],"ResetDrag",{},0,0],[[],"ComputeTransformForPortToPortMethod",{},0,0]],[]];
SPLM.RoutingCommon.MovePathBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.RoutingCommon.MovePathBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.RoutingCommon.MovePathBuilder.DetachTypes = Object.freeze({
    "AlwaysMaintainConnections" : "AlwaysMaintainConnections", "DetachSelectedObjects" : "DetachSelectedObjects"});

SPLM.RoutingCommon.MovePathBuilder.CopyMode = Object.freeze({
    "NoCopy" : "NoCopy", "CopyToWorkPart" : "CopyToWorkPart", "CopyToTarget" : "CopyToTarget"});

SPLM.RoutingCommon.MovePathBuilder.MoveType = Object.freeze({
    "Move" : "Move", "PortToPort" : "PortToPort"});

export default SPLM;